import { cn } from '@/lib/utils';
import Image from 'next/image';

type SquaredAvatarProps = React.ComponentProps<'div'> & {
  image?: string;
  name: string;
  size?: 'small' | 'medium' | 'large';
};

export default function SquaredAvatar({
  image,
  name,
  size = 'medium',
  ...props
}: SquaredAvatarProps) {
  const styles = {
    small: 'min-w-4 min-h-4 max-w-4 max-h-4 text-xs',
    medium: 'min-w-12 min-h-12 max-w-12 max-h-12 text-lg',
    large:
      'min-w-[168px] min-h-[168px] max-w-[168px] max-h-[168px] text-4xl rounded-md',
  };

  const firstLetter = name.charAt(0).toUpperCase();

  const width = size === 'small' ? 16 : size === 'medium' ? 48 : 168;
  const height = size === 'small' ? 16 : size === 'medium' ? 48 : 168;

  return (
    <div
      className={cn(
        'flex items-center justify-center overflow-hidden rounded-sm bg-gray-100 font-medium text-gray-600',
        styles[size]
      )}
      {...props}
    >
      {image ? (
        <Image src={image} alt={name} width={width} height={height} />
      ) : (
        firstLetter
      )}
    </div>
  );
}
